import React, { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';

import { makeStyles } from '@material-ui/core/styles';

import { SdmRichText, SdmTypography } from 'components';
import BoxContainer from './BoxContainer';
import { useDataHelper } from 'utils/dataHelper';
import { convertFromRaw, EditorState } from 'draft-js';
import { useIntl } from 'react-intl';
import translations from 'utils/translations';
import { theme } from 'theme';

const useStyles = makeStyles({
  inlineOptionsTextArea: {
    marginLeft: 'calc(100% - 167px)',
  },
  linkOptions: { right: '0 !important', left: 'unset !important' },
  editorWrapper: {
    border: '1px solid rgba(145, 158, 171, 0.32)',
    width: '100%',
    '& .rdw-editor-wrapper': {
      maxWidth: '100%',
    },
    '& a': {
      color: theme.colors.primary.red,
    },
  },
});

const SimpleRichText = ({
  control,
  name,
  getValues,
  defaultValue = '',
  customOnChange,
  maxChar = false,
  disabled = false,
}) => {
  // Hooks
  const intl = useIntl();
  const i18n = translations.productPage(intl);
  const classes = useStyles();
  const { parseRichText } = useDataHelper();
  const [countingChar, setCountingChar] = useState(-1);
  useEffect(() => {
    if (maxChar && typeof getValues(name) === 'string') {
      const startingValue = getValues(name);
      if (!startingValue) return setCountingChar(0);
      const value = JSON.parse(startingValue);
      const state = EditorState.createWithContent(convertFromRaw(value));
      const charLen = state.getCurrentContent().getPlainText('').length;
      setCountingChar(charLen);
    }
  }, [getValues(name), maxChar]);

  return (
    <BoxContainer className={classes.editorWrapper}>
      {countingChar >= 0 ? (
        <SdmTypography>
          {i18n.tooltip.characters}: {countingChar}/250
        </SdmTypography>
      ) : null}
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={(props) => (
          <SdmRichText
            readOnly={disabled}
            toolbarOverride={{
              options: ['inline', 'link'],
              inline: {
                options: ['bold', 'italic', 'underline'],
                className: classes.inlineOptionsTextArea,
              },
              link: {
                inDropdown: false,
                showOpenOptionOnHover: true,
                defaultTargetOption: '_self',
                options: ['link', 'unlink'],
                popupClassName: classes.linkOptions,
              },
            }}
            editorStyleOverride={{ maxWidth: '100%' }}
            onChange={(value) => {
              if (value?.blocks?.[0].text.trim().length !== 0) {
                props.onChange(value);
                customOnChange?.(value);
              } else {
                props.onChange(null);
                customOnChange?.(null);
              }
            }}
            id="description-required"
            value={parseRichText(getValues(name))}
            formControlStyle={{
              margin: 0,
            }}
            //readOnly={isFormDisabled()}
            onCountingChar={(value) => {
              if (maxChar) {
                setCountingChar(value);
              }
            }}
            maxChar={maxChar}
          />
        )}
      />
    </BoxContainer>
  );
};

export default SimpleRichText;
